import Mustache from "mustache";
export function loadGoogleMaps(apiKey) {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            return resolve(window.google.maps); // Already loaded
        }
        const scriptId = 'google-maps-script';
        if (document.getElementById(scriptId)) {
            return; // Already loading
        }
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=__onGoogleMapsLoaded`;
        script.async = true;
        script.defer = true;
        window.__onGoogleMapsLoaded = () => {
            resolve(window.google.maps);
            delete window.__onGoogleMapsLoaded;
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
const apiKey = 'AIzaSyAzQjdiwFAQ5WP90k_Du85bOXseRb2XRIs';
//Check to load the franchise maps
document.addEventListener('DOMContentLoaded', () => {
    const mapContainer = document.getElementById('franchise-map');
    if (!mapContainer)
        return;
    loadGoogleMaps(apiKey)
        .then(() => initMap(mapContainer))
        .catch((err) => console.error('Google Maps failed to load', err));
});
function initMap(container) {
    const map = new google.maps.Map(container, {
        zoom: 8,
        center: { lat: 0, lng: 0 },
    });
    const bounds = new google.maps.LatLngBounds();
    const infoWindow = new google.maps.InfoWindow();
    const template = document.getElementById('franchise-map-info-panel').innerHTML;
    //Load locations
    fetch("/ajax/getFranchises")
        .then(response => response.json())
        .then((locations) => {
        locations.forEach((location) => {
            const pos = { lat: location.lat, lng: location.lng };
            const marker = new google.maps.Marker({
                position: pos,
                map,
                title: location.name,
            });
            bounds.extend(pos);
            const rendered = Mustache.render(template, location);
            marker.addListener('click', () => {
                infoWindow.setContent(rendered);
                infoWindow.open(map, marker);
            });
        });
        map.fitBounds(bounds, 80); // Add some padding
    })
        .catch(e => {
        console.error(e);
    });
}
